module.exports = __webpack_public_path__ + "img/product32_scenario@2x.104a30e6.png";